import * as React from 'react';
import { Redirect } from 'react-router';
import * as _ from 'underscore';

import { DataConnections } from '../../../ts/resources/DataConnections';
import { DatasourceIdToConnectionIdsMap } from '../../../ts/ServerApi/types/DatasourceIdToConnectionIdsMap';
import { ServiceLocator } from '../../ServiceLocator';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface ExploreDatasourceProviderProps {
  readonly publishedDatasourceId: string;
  readonly urls: SpacesSiteUrls;
}

export interface ExploreDatasourceProviderState {
  readonly redirectDatasourceId: string;
  readonly hasError: boolean;
}

const InitialState: ExploreDatasourceProviderState = {
  redirectDatasourceId: undefined,
  hasError: false
};

export class ExploreDatasourceProvider extends React.PureComponent<ExploreDatasourceProviderProps, ExploreDatasourceProviderState> {
  private unmounted: boolean = false;

  public constructor(props: ExploreDatasourceProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (!_.isUndefined(this.state.redirectDatasourceId)) {
      return <Redirect to={this.props.urls.datasourcePath(this.state.redirectDatasourceId)} />;
    } else if (this.state.hasError) {
      return <RouterError errorType={'datasources'} urls={this.props.urls} />;
    }

    return null;
  }

  public async componentDidMount() {
    const DataConnections = ServiceLocator.get<DataConnections>('DataConnections');

    try {
      const datasourceIdToConnectionIdsMap: DatasourceIdToConnectionIdsMap =
        await DataConnections.getConnectionIdsFromDatasourceIds([this.props.publishedDatasourceId]);

      if (datasourceIdToConnectionIdsMap[this.props.publishedDatasourceId]) {
        const dsId: string = datasourceIdToConnectionIdsMap[this.props.publishedDatasourceId][0];
        this.updateState({redirectDatasourceId: dsId});

      } else {
        this.updateState({hasError: true});
      }

    } catch (e) {
      this.updateState({hasError: true});
    }
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof ExploreDatasourceProviderState>(newState: Pick<ExploreDatasourceProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
